/* =====================================================================
   ZEERO SCROLL MOTION (added 2026-10-07)
   Ported from the MFormula story-section engine. Styles: zeero-motion.css.

   MAP below = which element in which section gets which motion.
   Sections are not edited; this file finds them by their class names.
   To change a motion, change the effect name in MAP.

   Reveal once : up | title | clip | pop | glass   (gets .zm-in on screen)
   Scroll-linked: par | float | drift | light       (gets --zm-p 0..1)
   Options     : stagger -> siblings come in one after another
                 d       -> extra delay in ms
                 k       -> drift strength in px (array = per column)
                 byRow   -> trigger on the parent row (sideways sliders: cards
                            off to the right never count as on screen)

   To remove: delete this file + zeero-motion.css, and the
   "ZEERO SCROLL MOTION" block in layout/theme.liquid.
   ===================================================================== */
(() => {
  const MAP = {
    /* ---------- home ---------- */
    '.zr-series': [
      ['.zr-title', 'title'],
      ['.zr-sub', 'up', { d: 120 }],
      ['.zr-card', 'up', { stagger: true }],
      ['.zr-all', 'up'],
    ],
    '.zr-rt': [
      ['.zr-rt__badge', 'up'],
      ['.zr-rt__title', 'title', { d: 80 }],
      ['.zr-rt__body', 'up', { d: 200 }],
      ['.zr-rt__cta', 'up', { d: 300 }],
      ['.zr-rt__showcase', 'clip'],
      ['.zr-rt__showcase > img', 'par'],
      ['.zr-rt__grid > *', 'clip', { stagger: true, d: 200 }],
    ],
    '.zr-st': [
      // no 'par' on .zr-st__bg: it carries its own border-radius, scaling it squares the corners
      ['.zr-st__card', 'glass'],
      ['.zr-st__eyebrow', 'up', { d: 250 }],
      ['.zr-st__art', 'float'],
      ['.zr-st__item', 'light'],
      ['.zr-st__foot', 'up', { d: 150 }],
    ],
    '.zr-jr': [
      ['.zr-jr__title', 'title'],
      ['.zr-jr__body', 'up', { d: 150 }],
      ['.zr-jr__cell', 'clip', { stagger: true, d: 150 }],
      ['.zr-jr__cell', 'drift', { k: [0, 50, 20, 70] }],
      ['.zr-jr__caption', 'up', { stagger: true, d: 700 }],
    ],
    '.zcb': [
      ['.zcb__bg', 'par'],
      ['.zcb__heading', 'title'],
      ['.zcb__text', 'up', { d: 180 }],
      ['.zcb__button', 'glass', { d: 320 }],
    ],

    /* ---------- product pages ---------- */
    '.zfdc': [
      ['.zfdc__heading', 'title'],
      ['.zfdc__item', 'up', { stagger: true, d: 120 }],
      ['.zfdc__icon', 'pop', { stagger: true, d: 300 }],
      ['.zfdc__showcase > .zfdc__bg', 'par'],
      ['.zfdc__glass', 'glass'],
      ['.zfdc__media', 'pop', { d: 350 }],
    ],
    '.zil': [
      ['.zil__heading', 'title'],
      ['.zil__row', 'up', { stagger: true }],
      ['.zil__media', 'pop', { stagger: true, d: 200 }],
    ],
    '.zrt': [
      ['.zrt__bg', 'par'],
      ['.zrt__card', 'glass'],
      ['.zrt__heading', 'title', { d: 200 }],
      ['.zrt__item', 'light'],
      ['.zrt__footnote', 'up'],
    ],
    '.zhu': [
      ['.zhu__heading', 'title'],
      ['.zhu__step', 'up', { stagger: true, d: 120 }],
      ['.zhu__testing', 'up'],
      ['.zhu__cert', 'pop', { stagger: true, d: 150, byRow: true }],
    ],
    '.zrb': [
      ['.zrb__pill', 'up'],
      ['.zrb__card', 'up', { d: 120 }],
      ['.zrb__heading', 'title', { d: 250 }],
      ['.zrb__product', 'up', { stagger: true, d: 350 }],
      ['.zrb__foot', 'up', { d: 300 }],
    ],
    '.zmr': [
      ['.zmr__heading', 'title'],
      ['.zmr__card', 'up', { stagger: true, d: 120, byRow: true }],
      ['.zmr__nav', 'up', { d: 300 }],
    ],

    /* ---------- about ---------- */
    '.zsn': [
      ['.zsn__title', 'title'],
      ['.zsn__media', 'clip', { d: 120 }],
      ['.zsn__info', 'up', { d: 250 }],
      ['.zsn__pharmacy-head', 'up'],
      ['.zsn__finder', 'up', { d: 150 }],
    ],
    '.zps': [
      ['.zps__heading', 'title'],
      ['.zps__card', 'up', { stagger: true, d: 120, byRow: true }],
    ],
  };

  const REVEAL = { up: 1, title: 1, clip: 1, pop: 1, glass: 1 };
  const MAX_STAGGER = 6;
  const root = document.documentElement;
  if (!root.classList.contains('zm-on') || !('IntersectionObserver' in window)) {
    root.classList.remove('zm-on');
    return;
  }

  let vh = innerHeight;
  let raf = 0;
  const scrubbed = new Set();

  const waiting = new Map(); // trigger element -> elements it reveals
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      // shown when it enters, or straight away if the page loaded below it
      if (e.isIntersecting || e.boundingClientRect.bottom < 0) {
        (waiting.get(e.target) || []).forEach((el) => el.classList.add('zm-in'));
        waiting.delete(e.target);
        io.unobserve(e.target);
      }
    });
  }, { rootMargin: '0px 0px -12% 0px' });
  const watch = (trigger, el) => {
    if (!waiting.has(trigger)) { waiting.set(trigger, []); io.observe(trigger); }
    waiting.get(trigger).push(el);
  };

  function apply(section, instant) {
    Object.keys(MAP).forEach((sel) => {
      const roots = section.matches(sel) ? [section] : section.querySelectorAll(sel);
      roots.forEach((r) => {
        MAP[sel].forEach(([childSel, fx, opt = {}]) => {
          const els = [...r.querySelectorAll(childSel)];
          els.forEach((el, i) => {
            el.classList.add('zm-' + fx);
            if (REVEAL[fx]) {
              el.classList.add('zm');
              if (opt.d) el.style.setProperty('--zm-d', opt.d + 'ms');
              if (opt.stagger) el.style.setProperty('--zm-i', Math.min(i, MAX_STAGGER));
              // already on screen at load, or re-rendered in the editor: show, no animation
              const trigger = opt.byRow ? el.parentElement : el;
              const rect = trigger.getBoundingClientRect();
              if (instant || (rect.top < vh && rect.bottom > 0 && !section.dataset.zmSeen)) {
                el.classList.add('zm-in');
              } else {
                watch(trigger, el);
              }
            } else {
              if (opt.k != null) {
                const k = Array.isArray(opt.k) ? opt.k[i % opt.k.length] : opt.k;
                el.style.setProperty('--zm-k', k);
              }
              scrubbed.add(el);
            }
          });
        });
      });
    });
  }

  // transformed elements are measured by their parent so they cannot feed back into themselves
  const box = (el) => (el.classList.contains('zm-light') ? el : el.parentElement || el);

  function update() {
    raf = 0;
    // backup for IntersectionObserver: some environments never fire it, and a
    // missed reveal leaves content invisible. Same rule, checked on scroll.
    waiting.forEach((els, trigger) => {
      if (!trigger.isConnected) { waiting.delete(trigger); return; }
      const r = trigger.getBoundingClientRect();
      if (r.top < vh * 0.88 || r.bottom < 0) {
        els.forEach((el) => el.classList.add('zm-in'));
        waiting.delete(trigger);
        io.unobserve(trigger);
      }
    });
    scrubbed.forEach((el) => {
      if (!el.isConnected) { scrubbed.delete(el); return; }
      const r = box(el).getBoundingClientRect();
      if (r.bottom < -vh * 0.5 || r.top > vh * 1.5) return;
      const p = Math.min(1, Math.max(0, (vh - r.top) / (vh + r.height)));
      el.style.setProperty('--zm-p', p.toFixed(4));
    });
  }
  const req = () => { if (!raf) raf = requestAnimationFrame(update); };

  function init() {
    vh = innerHeight;
    document.querySelectorAll('.shopify-section').forEach((s) => apply(s, false));
    // first paint already happened; anything below the fold animates from here on
    document.querySelectorAll('.shopify-section').forEach((s) => { s.dataset.zmSeen = '1'; });
    update();
    setTimeout(req, 600); // late layout shifts (fonts, images) without a scroll
    addEventListener('scroll', req, { passive: true });
    addEventListener('resize', () => { vh = innerHeight; req(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (e) => { apply(e.target, true); update(); });
  }

  // a phone that switches "reduce motion" on mid-visit gets everything shown and still
  const rm = matchMedia('(prefers-reduced-motion: reduce)');
  const stopAll = () => { if (rm.matches) root.classList.remove('zm-on'); };
  if (rm.addEventListener) rm.addEventListener('change', stopAll);
})();
